import { Controller } from "@hotwired/stimulus"
import { Chart } from "chart.js/auto"
import "chartjs-adapter-date-fns"

export default class extends Controller {
  static targets = ["canvas"]
  static values = { datasets: Object }

  connect() {
    const colors = {
      "Article": { bg: "rgba(249, 115, 22, 0.7)", border: "rgb(249, 115, 22)" },
      "LinkedinJoke": { bg: "rgba(59, 130, 246, 0.7)", border: "rgb(59, 130, 246)" }
    }

    const labels = {
      "Article": "Article",
      "LinkedinJoke": "Joke"
    }

    const datasets = Object.entries(this.datasetsValue).map(([type, points]) => ({
      label: labels[type] || type,
      data: points.map(p => ({ x: p.x + "T00:00:00Z", y: p.y, url: p.url })),
      backgroundColor: colors[type]?.bg || "rgba(107, 114, 128, 0.7)",
      borderColor: colors[type]?.border || "rgb(107, 114, 128)",
      pointRadius: 6,
      pointHoverRadius: 8
    }))

    new Chart(this.canvasTarget, {
      type: "scatter",
      data: { datasets },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: { bottom: 20 } },
        onHover: (event, elements) => {
          event.native.target.style.cursor = elements.length && elements[0].element.$context.raw.url ? "pointer" : "default"
        },
        onClick: (_event, elements) => {
          if (!elements.length) return
          const url = elements[0].element.$context.raw.url
          if (url) window.location.href = url
        },
        scales: {
          x: {
            type: "time",
            time: { tooltipFormat: "MMM d" },
            title: { display: true, text: "Published date" }
          },
          y: {
            type: "logarithmic",
            title: { display: true, text: "Views" },
            afterBuildTicks: (axis) => {
              const ticks = []
              let v = 10
              while (v <= (axis.max || 100000)) {
                ticks.push({ value: v })
                v *= 2
              }
              axis.ticks = ticks
            },
            ticks: {
              callback: (value) => value.toLocaleString()
            }
          }
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y} views`
            }
          }
        }
      }
    })
  }
}
